<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
        <v-card-title>Follow Phone Number</v-card-title>

        <v-card-text>
            <v-select
                label="Phone Number to Follow"
                :items="items"
                v-model="value"
            />
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
                :disabled="value == null"
            >
            Ok
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>
const E164 = require('@/js/E164.js');
export default {

    data() {
        return {
            dialog: false,
            items: [],
            value: null,
        }
    },

    methods: {

        showDialog(not_following)
        {
            this.value = null;

            let items = [];

            for ( let i = 0; i < not_following.length; i++ )
            {
                items.push({
                    'text' : not_following[i].label + ' - '+E164.prettyPrintUsPhoneNumber(not_following[i].endpoint),
                    'value' : not_following[i].endpoint,
                });
            }

            this.items = items;

            this.dialog = true;
        },

        onOk()
        {
            this.dialog = false;
            this.$emit('ok', this.value);
        },

        onCancel()
        {
            this.dialog = false;
        },

    },
}
</script>

<style lang="scss" scoped>
</style>